import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setSelectedBuildingAction } from '../../../actions/instances/buildings';
import shortDateFormat from '../../../helpers/dates';
import './BuildingGridItem.scss';

const BuildingGridItem = ({
  building,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  return (
    <div
      className="grid-item"
      onClick={() => {
        dispatch(setSelectedBuildingAction(building));
        history.push('/buildings/view');
      }}
    >
      {building.images && building.images.length > 0 ? (
        <img src={building.images[0].url} alt={building.name} />
      ) : (
        <img src="/images/default.jpg" alt={building.name} />
      )}
      <span className="type">{`${building.building_type.name} [${building.building_type.code}]`}</span>
      <div className="overlay">
        <span className="building-name">{building.name}</span>
        <span className="dynasty d-block">{`${building.dynasty.name} [${building.dynasty.code}]`}</span>
        <span className="d-block">
          Created at
          {shortDateFormat(building.created_at)}
        </span>
      </div>
    </div>
  );
};

BuildingGridItem.propTypes = {
  building: PropTypes.any.isRequired,
};

export default BuildingGridItem;
